"use client";
import {useEffect, useState} from "react";
import {useFrontendConfiguratorContext} from "../../ProductConfigurator/context";

const Field = ({type = 'text', id, name, value, option, className, placeholder, onChange, prefix, suffix, min=undefined,max=undefined,step=undefined, showLabel = true, priceUnit = null}) => {

    const [disabled, setDisabled] = useState(false);
    const [visible, setVisible] = useState(option.is_visible && option.is_visible == '1' ? true : false);
    const {currentConfiguration} = useFrontendConfiguratorContext();
    const handleChange = (e) => {
        if (onChange && e?.target){
            let _value = e?.target?.value;
            if(type==='number' && _value){
                _value = _value.replace(/^0/g, '');
            }
            if(type==='number' && _value && _value.length > 5){
                return;
            }
            onChange({name: name, value: _value});
        }
    }

    useEffect(() => {


        // @TODO rewrite this for rule priority
        if (currentConfiguration.actions.filter(a => a.option === option.option_id && a.action === 'exclude').length > 0) {
            setDisabled(true);
            //confLog(option.title + ' disabled');
        } else {
            setDisabled(false);
        }

        if (currentConfiguration.actions.filter(a => a.option === option.option_id && a.action === 'hide').length > 0) {
            setVisible(false);
        } else if (currentConfiguration.actions.filter(a => a.option === option.option_id && a.action === 'show').length > 0) {
            setVisible(true);
        } else {
            setVisible(!!(option.is_visible && option.is_visible == '1'));
        }


    }, [currentConfiguration?.actions.filter(a => a.option === option.option_id)]);


    return <div className={` ${visible ? '' : 'hidden'}`}>
        {showLabel && <h3 className={'font-bold mb-0.5 capitalize text-lg lg:text-base'}>{option.title}{option.is_require == "1" && "*"}:</h3>}
        <div className={`flex w-full rounded border border-[#bdbdbd]`}>
            {prefix && <div className={'flex items-center justify-center px-3 text-gray-900 border-r border-[#bdbdbd]'}>{prefix}</div>}
            <input type={type}
                   id={id}
                   name={[`option`,`field`, option.option_id].join('_')}
                   aria-label={option.title}
                   className={[`grow h-[40px] py-1.5 ${(prefix && !suffix) ? 'rounded-r' : ''} ${(!prefix && suffix) ? 'rounded-l' : ''} ${(!prefix && !suffix) ? 'rounded' : ''} border-0`, className].join(' ')}
                   placeholder={placeholder}
                   value={value || ''}
                   onChange={handleChange}
                   onKeyDown={(e) => {
                          if (type === 'number' && (e.key === 'e' || e.key === '-' || e.key === '+' || e.key === '.' || e.key === ',' || e.key === 'E')) {
                            e.preventDefault();
                          }
                   }}
                   onPaste={(e) => {
                       if(type === 'number') {
                          e.preventDefault();
                       }
                   }}
                   maxLength={type === 'number' ? 5 : 230}
                   min={min}
                   max={max}
                   step={step}
            />
            {suffix && <div className={'flex items-center justify-center px-2 text-gray-900'}>{suffix}</div>}
        </div>
    </div>;

}

export default Field;